import { render, staticRenderFns } from "./UserComplex.vue?vue&type=template&id=517510cc&scoped=true"
import script from "./UserComplex.vue?vue&type=script&lang=js"
export * from "./UserComplex.vue?vue&type=script&lang=js"
import style0 from "./UserComplex.vue?vue&type=style&index=0&id=517510cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517510cc",
  null
  
)

export default component.exports